import React from 'react';
import { Img, Icon, Button } from 'components';
import { H2, Section, Box, Text } from 'styles';

export function Section2({ setRef }) {
  return (
    <Section ref={setRef} $scrollMarginTop={91} $mScrollMarginTop={107}>
      <H2 $display="none">Why N-Survey?</H2>
      <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Box $width="fit-content" $margin="auto">
          <Button $type="badge">
            <Icon name="badgeIcon" />
            Why N-Survey?
          </Button>
        </Box>
        <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
          왜 N-Survey 일까요?
        </Text>
        <Text $type="18" $mType="14" $textAlign="center" $color="gray600">
          다른 설문 패널과 차별화된 고품질 데이터 인프라
        </Text>
        <Box $margin="auto" $width="fit-content" $padding="64px 40px 80px" $mPadding="24px 0" $maxWidth={1600}>
          <Img desktopSrc="main2" mobileSrc="moMain2" $width="100%" $objectFit="cover" />
        </Box>
      </Box>
    </Section>
  );
}